var dialogInstance

const _factory = function (dialogRequest, setInstance) {
  if (dialogRequest && dialogRequest.killAll) {
    return dialogInstance && dialogInstance.killAll()
  }
  if (dialogRequest && dialogRequest.getInstance) {
    return dialogInstance
  }
  if (setInstance) {
    if (typeof this.queDialog === 'function') {
      if (dialogInstance) {
        console.warn('A valid VuePrompt instance was already defined', setInstance)
      }
      dialogInstance = this
    } else {
      console.warn('Not a valid VuePrompt instance', setInstance)
    }
  }
  if (dialogRequest) {
    if (dialogInstance) {
      setTimeout(function () {dialogInstance.queDialog(dialogRequest)}, 0)
    } else {
      console.warn('No VuePrompt instance to generate dialog.  Add <vue-prompt /> to your main App template', dialogRequest)
    }
  }
  return dialogRequest
}

const VuePromptPlugin = {
  install (Vue, options = {}) {
    Vue.prototype.$vPrompt = _factory
  }
}
export default VuePromptPlugin
